import { FormFieldTypes } from "../../../../../data/formFieldType";

export const DietaryRequirementFormData = {
    name: "DietaryRequirementFormData",
    initialState: {
        dietaryRequirement: "no",
    },
    formFields: [
        {
            id: "dietaryRequirement",
            label: "",
            Field_Name: "Dietary Requirement",
            fieldType: FormFieldTypes.RADIOBUTTON,
            dataField: "dietaryRequirement",
            fieldSetting: {
                placeholder: "",
                options: [
                    { label: "No dietary requirement", value: "no", isDisable: false, optionClass: "", },
                    { label: "There is dietary requirement", value: "yes", isDisable: false, optionClass: "ml-3", },
                ]
            },
            validation: [{ type: "require" }],
            style: {
                containerCss: "col-lg-4 my-4",
            },
        },
    ],
    formSetting: {
        isViewOnly: false
    }
}